import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SvgIcon, SvgIconSrc } from '../SvgIcon';
import { buttonVariants, Button } from '../Button';
const SubscriptionWarningBanner = ({ subscription = {} }) => {
  const [daysLeft, setDaysLeft] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const history = useHistory();
  const location = useLocation();

  // Check if banner should be hidden based on current page
  const shouldHideOnCurrentPage = () => {
    const currentPath = location.pathname;
    return (
      currentPath.includes('/subscription-suspended') ||
      currentPath.includes('/payment') ||
      currentPath.includes('/auth/') ||
      currentPath.includes('/select-company') ||
      currentPath.includes('/add-company')
    );
  };

  // Check sessionStorage on mount and when company changes
  useEffect(() => {
    if (subscription?.companyId) {
      const storageKey = `subscriptionBanner_${subscription.companyId}`;
      const isClosed = sessionStorage.getItem(storageKey);
      console.log('Subscription: Banner - Checking sessionStorage:', {
        storageKey,
        isClosed,
      });
      if (isClosed) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    }
  }, [subscription?.companyId]);

  // Reset banner when company changes
  useEffect(() => {
    if (subscription?.companyId) {
      setIsVisible(true);
    }
  }, [subscription?.companyId]);

  useEffect(() => {
    const calculateDaysLeft = () => {
      if (!subscription?.trialExpiryDate) return;

      const expiry = new Date(subscription?.trialExpiryDate);
      const now = new Date();
      const diff = Math.ceil((expiry - now) / (1000 * 60 * 60 * 24));
      setDaysLeft(diff);
    };

    calculateDaysLeft();
    const interval = setInterval(calculateDaysLeft, 60000); // Update every minute

    return () => clearInterval(interval);
  }, [subscription?.trialExpiryDate]);

  const handleUpgradeClick = () => {
    history.push('/subscription');
  };

  const handleClose = () => {
    setIsVisible(false);
    if (subscription?.companyId) {
      const storageKey = `subscriptionBanner_${subscription.companyId}`;
      const closeValue = `closed_${Date.now()}`;
      sessionStorage.setItem(storageKey, closeValue);
      console.log(
        'Subscription: Banner - Closed and saved to sessionStorage:',
        { storageKey, closeValue }
      );
    }
  };
  // Don't show if no subscription object, trial expired, user closed it, or subscription is active
  if (
    !subscription ||
    subscription.isTrialActive === false ||
    !subscription.trialExpiryDate ||
    daysLeft <= 0 ||
    !isVisible ||
    shouldHideOnCurrentPage() ||
    subscription.subscriptionStatus === 'active'
  ) {
    return null;
  }

  console.log(
    'Subscription: SubscriptionWarningBanner -> Trial Expiry Date:',
    subscription.trialExpiryDate
  );
  console.log(
    'Subscription: SubscriptionWarningBanner -> Days Left:',
    daysLeft
  );
  console.log(
    'Subscription: SubscriptionWarningBanner -> Is Visible:',
    isVisible
  );

  return (
    <div
      className="subscription-warning-banner"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1050,
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
        <SvgIcon src={SvgIconSrc.stopwatch} size={20} color="#856404" />
        <span
          style={{
            color: '#000',
            fontSize: '14px',
            marginLeft: '8px',
            fontWeight: '600',
          }}
        >
          Your trial expires in{' '}
          <strong style={{ color: '#1F74EC' }}>
            {daysLeft} {daysLeft === 1 ? 'day' : 'days'}.
          </strong>
        </span>
        <span
          style={{
            color: '#000',
            fontSize: '14px',
            marginLeft: '8px',
            fontWeight: '400',
          }}
        >
          Upgrade now for uninterrupted access.
        </span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Button
          icon={SvgIconSrc.crown}
          iconSize={20}
          iconColor="#fff"
          text="Upgrade Now"
          onClick={handleUpgradeClick}
          variant={buttonVariants.primary_rounded}
        />
        <button
          onClick={handleClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#856404',
            fontSize: '18px',
            cursor: 'pointer',
            padding: '4px',
            marginLeft: '8px',
          }}
          title="Close banner"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default SubscriptionWarningBanner;
